import { instanceValue } from '@wix/wix-instance-parser-js/dist/src';
import { parseQueryParams } from '../url';
export var getLinguisticHeaderFromUrl = function (url) {
    var _a = parseQueryParams(url), lang = _a.lang, dateNumberFormat = _a.dateNumberFormat, isPrimaryLanguage = _a.isPrimaryLanguage, instance = _a.instance;
    if (lang && dateNumberFormat && isPrimaryLanguage) {
        var instanceId = instanceValue.getValueFromInstance('instanceId', instance);
        return getLastLangValue(lang) + "|" + dateNumberFormat + "|" + isPrimaryLanguage + "|" + instanceId;
    }
};
var getLastLangValue = function (lang) {
    if (typeof lang === 'string') {
        return lang;
    }
    return lang.pop();
};
//# sourceMappingURL=linguistic-header.js.map